import { useAuthTokens, UserRole } from "modules/auth";
import { Navigate } from "react-router-dom";

import { PrivateRouteProps } from "./PrivateRoute.types";

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { accessToken, role } = useAuthTokens();

  if (!accessToken) return <Navigate to="/login" replace />;

  if (role === UserRole.DeliveryCompany || role === UserRole.CompanyManager) {
    return <Navigate to="/company" replace />;
  }

  return children;
};

export default PrivateRoute;
